const CUSTOM = 'Custom';
const ELITE = 'Elite';
const FULL_SERVICE = 'Full Service';
const PAY_AS_YOU_GO = 'Pay As You Go';
const PLUS = 'Plus';
const PRO = 'Pro';
const STARTER = 'Starter';

export const displayNames = {
    CUSTOM,
    ELITE,
    FULL_SERVICE,
    PAY_AS_YOU_GO,
    PLUS,
    PRO,
    STARTER,
};

export const HIGHEST_PLAN_NAME = 'Professional Yearly';
